import React from "react";

const LearningLevelsSection = () => {
  const learningLevels = [
    {
      title: "Brand New",
      description: "Get two left feet? Start with our 10-day intro program.",
      gradient: "bg-gradient-to-r from-purple-400 to-pink-400",
    },
    {
      title: "Beginner",
      description: "Get the basics down? Level up with new moves and routines.",
      gradient: "bg-gradient-to-r from-blue-400 to-teal-400",
    },
    {
      title: "Intermediate",
      description: "Feel pretty confident? Learn more challenging skills and pieces.",
      gradient: "bg-gradient-to-r from-yellow-400 to-orange-400",
    },
    {
      title: "Advanced",
      description: "Already killin' it? Train with the top choreographers in the game.",
      gradient: "bg-gradient-to-r from-green-400 to-cyan-400",
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-purple-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-gray-800 mb-6 sm:mb-12">
          Step-by-Step Learning For All Levels
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-center text-gray-600 mb-10 sm:mb-16 max-w-3xl mx-auto">
          Whether you're just starting out or you've got some training under your
          belt — we got you covered.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {learningLevels.map((level, index) => (
            <div
              key={index}
              className={`${level.gradient} rounded-lg shadow-lg text-white p-6 sm:p-8 transform transition-transform duration-300 hover:scale-105`}
            >
              <h3 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-4">
                {level.title}
              </h3>
              <p className="text-sm sm:text-base lg:text-lg">
                {level.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LearningLevelsSection;
